<template>
	<sc-table-select
		ref="tableselect"
		v-model="goodsvalue"
		:attrList="attrList"
		:valueList="valueList"
		:queryList="queryList"
		:orderList="orderList"
		:table-width="640"
		collapse-tags
		collapse-tags-tooltip
		:props="props"
		@change="change"
	>
		<template #header="{}">
			<el-form :inline="true">
				<el-row :gutter="5"
					><el-col :span="5">
						<el-input
							v-model="queryList.Code"
							placeholder="请输入物品编码"
							style="width: 120px"
						></el-input></el-col
					><el-col :span="5">
						<el-input
							v-model="queryList.Name"
							placeholder="请输入物品名称"
							style="width: 120px"
						></el-input> </el-col
					><el-col :span="5"
						><el-select
							v-model="queryList.TypeCode"
							placeholder="请选择物品类型"
							style="width: 120px"
							clearable
							:teleported="false"
						>
							<el-option
								label="---请选择---"
								value=""
							></el-option>
							<el-option label="直营店" value="01"></el-option>
							<el-option
								label="加盟店"
								value="02"
							></el-option> </el-select></el-col
					><el-col :span="5">
						<el-select
							v-model="queryList.State"
							placeholder="请选择机构状态"
							clearable
							:teleported="false"
							style="width: 120px"
						>
							<el-option
								label="---请选择---"
								value=""
							></el-option>
							<el-option label="禁用" value="0"></el-option>
							<el-option
								label="正常"
								value="1"
							></el-option> </el-select></el-col
					><el-col :span="4">
						<el-button
							type="primary"
							@click="$refs.tableselect.getData()"
							>查询</el-button
						></el-col
					></el-row
				>
			</el-form>
		</template>
		<el-table-column
			prop="GoodsCode"
			label="物品编码"
			width="100"
		></el-table-column>
		<el-table-column
			prop="GoodsName"
			label="物品名称"
			width="180"
		></el-table-column>
		<el-table-column
			prop="Standard"
			label="规格"
			width="150"
		></el-table-column>
		<el-table-column
			prop="OrderTypeName"
			label="大类"
			width="120"
		></el-table-column>
		<el-table-column
			prop="OrderSubTypeName"
			label="小类"
			width="150"
		></el-table-column>
		<el-table-column
			prop="UomName"
			label="单位"
			width="100"
		></el-table-column>
		<el-table-column
			prop="GroupTypeName"
			label="组别"
			width="120"
		></el-table-column>
	</sc-table-select>
</template>

<script>
export default {
	name: "goodsSelect",
	data() {
		return {
			attrList: {
				Name: "Goods",
				UseDistinct: false,
				OrgCode: "",
				UseBackUp: false,
				UseGroup: false,
			},
			valueList: {
				Code: "GoodsCode",
				Name: "GoodsName",
				Standard: "Standard",
				UomCode: "UomCode",
				UomName: "UomName",
				OrderTypeName: "OrderTypeName",
				OrderSubTypeName: "OrderSubTypeName",
				GroupTypeName: "GroupTypeName",
				State: "State",
			},
			queryList: {
				Code: "",
				Name: "",
				OrderTypeCode: "",
				OrderSubTypeCode: "",
				GroupTypeCode: "",
				IsOrder: "1",
				State: "1",
			},
			//apiObj: this.$API.demo.page,
			params: {
				name: "demoName",
			},
		};
	},
	computed: {},
	mounted() {},
};
</script>

<style scoped></style>
